import { getDatalayerValue } from "../../assets/js/utils";

export class MerkurEvent {
    constructor(eventName, data) {
        this.eventName = eventName;
        this.data = data;
    }

    send() {
        const eventdata = this.build();
        const { trackGenericEvent } = window.merkur;
        trackGenericEvent(this.eventName, eventdata);
    }

    build() {
        const data = {
            suchbegriff: getDatalayerValue("suchbegriff") || "",
            fusionQueryId: getDatalayerValue("fusionqueryid") || this.data["trackingtoken"] || "",
            asn: getDatalayerValue("asnaktiv") || false,
            seite: this.data["seite"] || "",
            position: this.data["position-aus-sicht-suchmaschine"] || "",
            matnr: this.data["product-id"] || "",
            preis: this.data["price"] || "",
            trackingToken: this.data["trackingtoken"] || "",
            adId: this.data["rmt-adid"] || "",
            quelle: this.data["quelle"] || ""
        }
        return data;
    }
}
